import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  constructor() {}

  getDate() {
    let d = new Date()
    d.setHours(d.getHours() - d.getTimezoneOffset() / 60)
    let day = d.getDate() > 9 ? d.getDate() : '0' + d.getDate()
    let month = d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)
    return day + '/' + month + '/' + d.getFullYear()
  }
}
